"use client";

import { useState, useEffect } from "react";
import { initializeAnalytics } from "../lib/firebase";
import { logEvent } from "firebase/analytics";

export default function useAnalytics() {
  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    const initAnalytics = async () => {
      const analyticsInstance = await initializeAnalytics();
      if (analyticsInstance) {
        setAnalytics(analyticsInstance);
      }
    };

    initAnalytics();
  }, []);

  const trackEvent = (eventName, eventParams = {}) => {
    if (!analytics) return;
    
    try {
      logEvent(analytics, eventName, eventParams);
    } catch (error) {
      console.error(`Error logging event ${eventName}:`, error);
    }
  };

  return { analytics, trackEvent };
}
